var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestimonials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_424_7658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8569 0.857143H4.28551C3.83084 0.857143 3.39481 1.03776 3.07332 1.35925C2.75184 1.68074 2.57122 2.11677 2.57122 2.57143V18L0.856934 23.1429L7.71408 21.4286H21.4284C21.883 21.4286 22.3191 21.2479 22.6405 20.9265C22.962 20.605 23.1426 20.1689 23.1426 19.7143V11.1429",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3367 13.9488L9.19385 14.8745L10.051 9.6631L18.1596 1.58882C18.3189 1.42814 18.5085 1.30061 18.7175 1.21358C18.9263 1.12654 19.1503 1.08174 19.3768 1.08174C19.6031 1.08174 19.8271 1.12654 20.0359 1.21358C20.2449 1.30061 20.4345 1.42814 20.5939 1.58882L22.4111 3.40596C22.5717 3.56532 22.6992 3.75492 22.7863 3.96382C22.8732 4.17273 22.9181 4.3968 22.9181 4.6231C22.9181 4.84941 22.8732 5.07348 22.7863 5.28238C22.6992 5.49129 22.5717 5.68089 22.4111 5.84025L14.3367 13.9488Z",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_424_7658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonials);
export default __webpack_public_path__ + "static/media/testimonials.6ab2754e2166d1d01e80a9920eb925cd.svg";
export { ForwardRef as ReactComponent };